import { Media } from 'react-bootstrap'
import Link from 'next/link'
import { Request } from '@group-devs/yfp7-global-modules'

const request = new Request(process.env.apiDomain)

function MemberBenefits(props) {

    const site = props.props.site

    const { data: profile  } = request.account.swrAccountProfile(site.accountId)
    const { data: shaklee } = request.account.swrShakleeInfo(site.accountId, profile ? profile.user.id : profile)
    const country  = shaklee ? shaklee.shaklee_country : 'us'

    return (
        <div className="d-md-flex align-items-center justify-content-between my-5 py-3 mx-lg-5 px-lg-5">
            <Media>
                <img width={64} src="../images/test/member.png" alt="Generic placeholder" className="img-fluid mr-3"/>
                <Media.Body className="d-md-flex justify-content-between align-items-center ">
                    <div>
                        <h5 className="h6"><strong>Member Benefits</strong></h5>
                        <p className="h7">
                            Discover the perks of being a Preferred Member <br className="d-md-block d-none"/> so you can live well, naturally.
                        </p>
                    </div>
                    <Link href={shaklee ? "https://"+country+".shaklee.com/member-benefits/join-options?pwsName="+shaklee.shaklee_pws_name+"" : ""}><a className="px-4 py-2 btn-green text-uppercase text-white h7 btnjoin">Join now</a></Link>
                </Media.Body>
            </Media>
    <style jsx>{`
       
            @media(min-width:768px){
                .btnjoin{
                    margin-left:8rem;
                 }
            }
       
    `}</style>
        </div>
    )
}

export default MemberBenefits
